import React from 'react';
import {
  Image,
  StyleSheet,
  Text,
  TouchableHighlight,
  View,
} from '../base_components';

import CoinPickerOverlay from '../overlays/coin_picker_overlay';
import ModalContent from '../modal_content';

import CoinStore from '../../stores/coin_store';
import WalletStore from '../../stores/wallet_store';
import EthTools from '../../tools/eth_tools';

import { numberToDisplay } from '../../tools/util';

const styles = StyleSheet.create({
  coinSelect: {
    marginLeft: '1rem',
    marginRight: '1rem',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  inputWrapper: {
    alignSelf: 'stretch',
    height: '5rem',
    backgroundColor: '#eee',
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: '#ddd',
    borderRadius: '0.5rem',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    overflow: 'hidden',
  },
  inner: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  placeholder: {
    marginLeft: '1.5rem',
    color: '#757575',
    fontSize: '1.4rem',
  },
  spacer: {
    flex: 1,
  },
  down: {
    marginRight: '1rem',
    width: '1.2rem',
    height: '1.2rem',
  },
  coin: {
    marginLeft: '1rem',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  coinTop: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageView: {
    marginLeft: '1rem',
    width: '3.5rem',
    height: '3.5rem',
    borderRadius: '0.2rem',
    backgroundColor: '#333',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: '3.5rem',
    height: '3.5rem',
    borderRadius: '0.2rem',
  },
  iconText: {
    color: 'white',
    fontSize: '2rem',
  },
  middle: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  symbolChain: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  symbol: {
    color: '#333',
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
  chain: {
    marginTop: '0.2rem',
    marginLeft: '0.5rem',
    color: '#555',
    fontSize: '1rem',
  },
  balanceView: {
    marginTop: '0.5rem',
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  balanceText: {
    color: '#333',
    fontSize: '1.2rem',
  },
});

const DOWN_IMG = require('../../assets/img/down_black.png');

type Props = {
  style?: any;
  otherCoin?: any;
  value: any;
  placeholder: string;
  onSelect: (coin: any) => void;
};
export default class CoinSelect extends React.PureComponent<Props> {
  componentDidMount() {
    WalletStore.addChangeListener(this._onWalletUpdate);
    CoinStore.addChangeListener(this._onCoinUpdate);
    if (this.props.value) {
      CoinStore.fetchBalance(this.props.value);
    }
    this._onCoinUpdate();
  }
  componentWillUnmount() {
    WalletStore.removeChangeListener(this._onWalletUpdate);
    CoinStore.removeChangeListener(this._onCoinUpdate);
  }
  _onWalletUpdate = () => {
    if (this.props.value) {
      CoinStore.fetchBalance(this.props.value);
    }
  };
  _onCoinUpdate = () => {
    this.forceUpdate();
  };
  _onPress = () => {
    const overlay = (
      <CoinPickerOverlay
        otherCoin={this.props.otherCoin}
        onSelect={this._onSelect}
        onDone={this._onDone}
      />
    );
    ModalContent.showOverlay(overlay);
  };
  _onSelect = (coin) => {
    this.props.onSelect(coin);
    CoinStore.fetchBalance(coin);
    ModalContent.hideOverlay();
  };
  _onDone = () => {
    ModalContent.hideOverlay();
  };
  render() {
    const { style, value, placeholder } = this.props;
    let content = null;
    if (value) {
      const balance = CoinStore.getBalance(value);
      const { icon_uri, symbol, chain_id } = value;
      let image = null;
      if (icon_uri) {
        image = (
          <Image
            style={styles.icon}
            resizeMode='contain'
            source={{ uri: icon_uri }}
          />
        );
      } else {
        image = (
          <Text style={styles.iconText}>
            {symbol.substr(0, 1).toUpperCase()}
          </Text>
        );
      }
      const chain = EthTools.getChainName(chain_id);

      let balance_view = null;
      if (balance !== undefined) {
        balance_view = (
          <View style={styles.balanceView}>
            <Text style={styles.balanceText}>
              Balance: {numberToDisplay(balance)} {symbol}
            </Text>
          </View>
        );
      }

      content = (
        <>
          <View style={styles.imageView}>{image}</View>
          <View style={styles.coin}>
            <View style={styles.coinTop}>
              <View style={styles.middle}>
                <View style={styles.symbolChain}>
                  <Text style={styles.symbol}>{symbol}</Text>
                  <Text style={styles.chain}>({chain})</Text>
                </View>
              </View>
            </View>
            {balance_view}
          </View>
        </>
      );
    } else {
      content = (
        <>
          <Text style={styles.placeholder}>{placeholder}</Text>
          <View style={styles.spacer} />
        </>
      );
    }

    return (
      <View style={[styles.coinSelect, style]}>
        <TouchableHighlight
          style={styles.inputWrapper}
          underlayColor='rgba(0,0,0,0.3)'
          onPress={this._onPress}
        >
          <View style={styles.inner}>{content}</View>
          <Image style={styles.down} resizeMode='contain' source={DOWN_IMG} />
        </TouchableHighlight>
      </View>
    );
  }
}
